function isOnScreen(e) {
  var s, t, o, a, i;
  if (e.length !== 0) {
    o = (s = (t = jQuery(window)).scrollTop()) + (t = t.height());
    i = (a = (e = jQuery(e)).offset().top) + (e = e.height());
    return (
      (s <= a && a < o) ||
      (s < i && i <= o) ||
      (t < e && a <= s && o <= i)
    );
  }
}

function nutrients(e, s) {
  var t, o, a;
  for (t = 0, o = document.getElementsByClassName("tabcontent2"); t < o.length; t++) {
    o[t].style.display = "none";
  }
  for (t = 0, a = document.getElementsByClassName("tablinks2"); t < a.length; t++) {
    a[t].className = a[t].className.replace(" active", "");
  }
  document.getElementById(s).style.display = "block";
  e.currentTarget.className += " active";
}

function GetStoreMarker() {
  window.location.hash = "#contentOurIngr";
}

jQuery(document).ready(function () {
  window.addEventListener("scroll", function (e) {
    var s = jQuery(".ProductForm__AddToCart");
    if (isOnScreen(jQuery(".price-container"))) {
      console.log("The specified container is in view.");
      if (s.hasClass("tech")) s.removeClass("tech");
    } else {
      if (!s.hasClass("tech")) s.addClass("tech");
    }
  });

  jQuery(function () {
    jQuery(".gs-header").on("click", function () {
      if (jQuery(window).width() <= 749) {
        var e = jQuery(this).attr("aria-expanded");
        console.log("Expanded " + e);
        if (e === "false") {
          jQuery(this).addClass("active");
          jQuery(this).next(".gs-content").slideDown();
          console.log("open");
          jQuery(this).attr("aria-expanded", "true");
        } else if (e === "true") {
          jQuery(this).removeClass("active");
          jQuery(this).next(".gs-content").slideUp();
          console.log("close");
          jQuery(this).attr("aria-expanded", "false");
        }
      }
    });

    $(".products-carousel").slick({
      draggable: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 2, slidesToScroll: 2 },
        },
        {
          breakpoint: 600,
          settings: { slidesToShow: 2, slidesToScroll: 2, dots: true, arrows: true },
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: true },
        },
      ],
    });

    $(".ingredient_img").slick({
      slidesToScroll: 1,
      variableWidth: false,
      infinite: true,
      initialSlide: 1,
      arrows: true,
    });

    $("#featured_nutrients").owlCarousel({
      loop: true,
      margin: 10,
      items: 1,
      dots: true,
      nav: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });

    $("#our_ingredient").owlCarousel({
      loop: true,
      margin: 10,
      dots: true,
      nav: true,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: {
        0: { items: 1 },
        480: { items: 2 },
      },
    });

    $(".icon-marquee__marquee-inner").slick({
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: false,
      cssEase: "linear",
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    });

    $(".icon-marquee__marquee-inner-new").slick({
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: false,
      cssEase: "linear",
      slidesToShow: 1,
      draggable: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    });

    $(".press-carousel").owlCarousel({
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 4000,
      autoplayHoverPause: false,
      autoplaySpeed: 4000,
      dots: false,
      loop: true,
      nav: false,
      center: false,
      responsive: {
        0: { items: 2 },
        640: { items: 3 },
        1000: { items: 4 },
      },
    });

    $(".logo_slide").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        { breakpoint: 9999, settings: "unslick" },
        {
          breakpoint: 749,
          settings: {
            useTransform: false,
            slidesToShow: 3,
            speed: 200,
            slidesToScroll: 3,
            cssEase: "linear",
            centerPadding: "50px 0 0",
            arrows: false,
            dots: true,
          },
        },
      ],
    });

    $(".btm_mlt .mob_slide").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        { breakpoint: 9999, settings: "unslick" },
        {
          breakpoint: 749,
          settings: {
            useTransform: false,
            slidesToShow: 3,
            speed: 200,
            slidesToScroll: 3,
            cssEase: "linear",
            centerPadding: "50px 0 0",
            arrows: false,
            dots: true,
          },
        },
      ],
    });

    $(document).on("click", ".tablink", function () {
      var e = $(this).attr("data-char");
      $(".tabcontent").css("display", "none");
      $(".tablink").removeClass("active");
      document.getElementById(e).style.display = "block";
      $(this).addClass("active");
    });

    document.getElementById("defaultOpen").click();
  });
});
